export default "__VITE_ASSET__9vSoPp96__"